import * as React from "react";

export interface TestimonialImageProps {
  src: string;
}

const TestimonialImage = (props: TestimonialImageProps) => (
  <div className="testimonial-carousel__item">
    <img className="img-responsive" src={props.src} />
  </div>
);

export default TestimonialImage;



// WEBPACK FOOTER //
// ./src/routes/TestimonialsCarousel/components/TestimonialImage.tsx